import React from 'react';
import { observer } from 'mobx-react';
import { Send } from '@material-ui/icons';
import { Form, Formik } from 'formik';

import { RootStoreContext } from '../../../../../../context';
import './MessageInput.css';
import RecordAudio from '../../../../../RecordAudio/RecordAudio';
import RichTextField from '../RichTextField/RichTextField';
import { sendRichMessagePrivateChat } from '../../../../../App/services';
import SaasLogger from '../../../../../../services/SaasLogger';

import withUser from './withUser';


const MAX_MESSAGE_LENGTH = 500;

@withUser
@observer
class MessageInput extends React.Component {

  static contextType = RootStoreContext;

  state = {
    expandedControls: false,
    message: '',
    messageMetadata: null,
  };

  inputRef = React.createRef();
  containerRef = React.createRef();

  inputHeight = 0;

  componentWillUnmount() {
    this.context.privateMessagingStore.setInputAreaHeight(0);
  }

  sendMessage = (e) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    const { message, messageMetadata } = this.state;
    const { activeConversationName } = this.context.privateMessagingStore;
    if (!message.length) {
      return;
    }

    if (!messageMetadata?.entityMap?.['0']) {
      this.context.privateMessagingStore.sendMessage(message);
    } else {
      sendRichMessagePrivateChat(activeConversationName, { message, messageMetadata: JSON.stringify(messageMetadata) }).then((res) => {
        if (res.status !== 201) {
          SaasLogger.error('Error Sending message');
        }
      }).catch((err) => SaasLogger.error(`Error Sending Message ${err}`));
    }

    this.setState({
      message: '',
      messageMetadata: null,
    });
    if (this.inputRef && this.inputRef.current) {
      this.inputRef.current.clear();
    }
  };

  dataAvailableRecordAudio = (payload) => {
    this.context.privateMessagingStore.sendAudioMessage(payload);
  };

  expandedCallbackRecordAudio = (state) => {
    this.setState({ expandedControls: state });
  };

  onInputKeyPress = (event) => {
    if ((event.charCode === 13 || event.keyCode === 13) && !event.shiftKey) {
      this.sendMessage(event);
    }
  };

  onMessageChange = (e) => {
    this.setState({
      message: e.target.value,
      messageMetadata: e.target.meta,
    });
  };

  render() {
    const { expandedControls, message, messageMetadata } = this.state;
    const { user, anchorSubscriptions } = this.props;
    const isAnchor = user.user.account.anchor;
    const inputWrapperClassName = `
      inputWrapper ${expandedControls ? 'expanded' : ''} 
      ${!isAnchor ? 'addBorderRight' : ''}
    `;

    return (
      <div ref={this.containerRef} id="private-chat-message-input">
        <Formik
          initialValues={{ message: '' }}
          onSubmit={this.sendMessage}
        >
          {(props) => {
            const hintTextVisible = props.values.message.length > 3;

            return (
              <Form autoComplete={'off'}>
                <div className="wrapper">
                  <div className={inputWrapperClassName}>
                    <RichTextField
                      ref={this.inputRef}
                      anchorSubscriptions={anchorSubscriptions}
                      className="form-input-box"
                      inputProps={{ className: 'form-text-input', maxLength: MAX_MESSAGE_LENGTH }}
                      isFan={!isAnchor}
                      multiline={true}
                      name="message"
                      placeholder="Type something..."
                      type="text"
                      value={message}
                      valueMeta={messageMetadata}
                      onChange={this.onMessageChange}
                      onKeyDown={this.onInputKeyPress}
                    />
                    <div>
                      <button className="send-icon" type="submit" onClick={this.sendMessage} >
                        <Send fontSize="inherit" />
                      </button>
                    </div>
                  </div>
                  {isAnchor && (
                    <RecordAudio
                      dataAvailable={this.dataAvailableRecordAudio}
                      expandedCallback={this.expandedCallbackRecordAudio}
                    />
                  )}
                </div>
                <div
                  className={`controls-hint ${hintTextVisible ? 'controls-hint--visible' : ''}`}
                >
                  <code>Enter</code> send &nbsp;&nbsp; <code>Shift+Enter</code> new line
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  }
}

export default MessageInput;
